import React from 'react'
import {Link} from 'react-router-dom'
import {Button, Media} from 'reactstrap'
import UserIcon from 'react-icons/lib/fa/user'
import RemoveIcon from 'react-icons/lib/fa/close'
import SFLogo from '../../images/sf-logo-simple.png'

let TeamMemberListTableRow = ({user, currentUserID, currentUserIsSupport, onCheckboxChangeForUser, onRemoveUserClicked}) =>
    <tr className={(user.id === currentUserID ? "bg-muted-sf-orange" : "")}>
        <td className="text-left d-none d-md-table-cell">
            {user.isSupport ?
                <Media object src={SFLogo} className="inline-media-icon" alt="Support User"/> :
                <UserIcon/>}
        </td>
        <td className="text-left d-table-cell d-sm-none xs-name-cell">
            {currentUserIsSupport ?
                <Link to={`/users/${user.id}`}>{user.name}</Link>:
                user.name}
        </td>
        <td className="text-left d-none d-sm-table-cell d-md-none sm-name-cell">
            {currentUserIsSupport ?
                <Link to={`/users/${user.id}`}>{user.name}</Link>:
                user.name}
        </td>
        <td className="text-left d-none d-md-table-cell">
            {currentUserIsSupport ?
                <Link to={`/users/${user.id}`}>{user.name}</Link>:
                user.name}
        </td>
        <td className="text-center">
            <input className="form-check-input team-permission" type="checkbox"
                   onChange={(e) => {
                       onCheckboxChangeForUser(user, e.target.name, e.target.checked)
                   }}
                   defaultChecked={user.canViewControllers} name="canViewControllers"/>
        </td>
        <td className="text-center">
            <input className="form-check-input team-permission" type="checkbox"
                   onChange={(e) => {
                       onCheckboxChangeForUser(user, e.target.name, e.target.checked)
                   }}
                   defaultChecked={user.canViewData} name="canViewData"/>
        </td>
        <td className="text-center">
            <input className="form-check-input team-permission" type="checkbox"
                   onChange={(e) => {
                       onCheckboxChangeForUser(user, e.target.name, e.target.checked)
                   }}
                   defaultChecked={user.canSendCommands} name="canSendCommands"/>
        </td>
        <td className="text-center">
            <input className="form-check-input team-permission" type="checkbox"
                   onChange={(e) => {
                       onCheckboxChangeForUser(user, e.target.name, e.target.checked)
                   }}
                   defaultChecked={user.canManageTeam} name="canManageTeam"/>
        </td>
        <td className="pl-0 pr-0 pl-sm-1 pr-sm-1">
            <Button color="danger"
                    className={currentUserID === user.id ? "invisible" : ""}
                    onClick={() => onRemoveUserClicked(user)}>
                <RemoveIcon/>
            </Button>
        </td>
    </tr>

export default TeamMemberListTableRow



// WEBPACK FOOTER //
// ./src/components/ui/TeamMemberListTableRow.js